import { FC, useState } from 'react';
import { ArrowdropdownIcon, FiltersIcon } from '../../../assets/icons';

type FiltersProps = {
  options: { [key: string]: any };
  onChange: any;
};

type DropdownProps = {
  title: string;
  items: any;
  onChange: any;
};

const Filters: FC<FiltersProps> = ({ options, onChange }) => {
  // const isActive = Object.values(options).some(
  //   (item) => item && item?.some((i: any) => i?.value)
  // );

  return (
    <div className='max-h-max p-2'>
      <div className='flex justify-between'>
        <p className='text-sm flex gap-1'>
          <FiltersIcon className='w-5 h-5 mt-[1px] !text-[#3362DA]' />
          Filters
        </p>
        <p className='text-xs cursor-pointer text-blue-900' onClick={() => onChange('clearAll')}>
          Clear All
        </p>
      </div>

      <div className='mt-2'>
        {Object.entries(options)?.map(([key, items], index) => (
          <Dropdown key={index} title={key} items={items} onChange={onChange} />
        ))}
      </div>
    </div>
  );
};

const Dropdown: FC<DropdownProps> = ({ title, items, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className='w-full'>
      <div
        className='flex justify-between items-center cursor-pointer  bg-blue-100 hover:bg-blue-200 rounded-md p-1'
        onClick={toggleDropdown}
      >
        <span className={`text-[12px] ${isOpen ? 'text-[#3362DA]' : ''}`}>{title}</span>
        <ArrowdropdownIcon className={`w-4 h-4 transform ${isOpen ? 'rotate-180' : 'rotate-0'}`} />
      </div>
      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
        }`}
        style={{ transitionProperty: 'max-height, opacity' }}
      >
        {isOpen && (
          <div className='p-2  shadow-md space-y-2 bg-slate-100 rounded-md'>
            {items?.map((item: any, index: number) => (
              <div key={index} className='flex items-center'>
                <input
                  type='checkbox'
                  className=' mr-2 appearance-noneborder border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-transparent focus:outline-none transition duration-200 cursor-pointer'
                  onChange={() => onChange(title, item, index)}
                  checked={Boolean(item?.value)}
                />
                <span className='text-xs'>{item.title}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Filters;
